<form [formGroup]="form" class="align-form">
    <mat-form-field>
        <mat-label>{{fieldDetails?.name}}</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="{{fieldDetails?.id}}" [max]="maxDate"
            (click)="picker.open()" readonly>
        <!-- <mat-hint>MM/DD/YYYY</mat-hint> -->
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <ng-container *ngIf="userSubmit && formValues[fieldDetails?.id].errors">
            <mat-error *ngIf="formValues[fieldDetails?.id].errors?.['required']">
                <em class="fas fa-exclamation-circle mr-2"></em>{{fieldDetails?.name}} is required
            </mat-error>
        </ng-container>
    </mat-form-field>
</form>